import {UPDATE_DAILY_BUDGET} from './actions';

export function dailyBudget(state: DailyBudgetState, {type, payload}: Action): DailyBudgetState {
  switch (type) {
    case UPDATE_DAILY_BUDGET:
      return {...(payload as DailyBudgetState)};

    default:
      return state;
  }
}
